import React, { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface OrderSummaryProps {
  shipping: number;
  total: number;
  tax: number;
  subtotal: number;
  cartItems: any[];
}

const OrderSummary = ({shipping, total, tax, subtotal, cartItems}: OrderSummaryProps) => {
  const itemCount = useMemo(() => cartItems.length, [cartItems]);

  return (
    <Card className="border shadow-sm">
      <CardHeader className="pb-4">
        <CardTitle>Order Summary</CardTitle>
        <p className="text-sm text-gray-500">
          {itemCount} item{itemCount !== 1 ? "s" : ""} in your cart
        </p>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-3">
            {cartItems.map((item) => (
              <div
                key={item?.id}
                className="flex items-center justify-between pb-3 border-b"
              >
                <div className="flex items-center space-x-3">
                  <img
                    src={item?.images?.[0] || item?.variant?.images?.[0] || item?.image || item?.product?.image || "/placeholder.svg"}
                    alt={item?.name || item?.variant?.name || item?.product?.name}
                    className="w-12 h-12 object-cover rounded-md border"
                  />
                  <div>
                    <p className="font-medium">{item?.name || item?.variant?.name || item?.product?.name}</p>
                    <p className="text-sm text-gray-500">Qty: {item?.quantity}</p>
                  </div>
                </div>
                <p className="font-medium">${((item?.price || item?.variant?.price || 0) * (item?.quantity ?? 1)).toFixed(2)}</p>
              </div>
            ))}
          </div>

          <div className="space-y-2">
            <div className="flex justify-between">
              <p className="text-gray-600">Subtotal</p>
              <p className="font-medium">${subtotal?.toFixed(2)}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-gray-600">Shipping</p>
              <p className="font-medium">${shipping?.toFixed(2)}</p>
            </div>
            <div className="flex justify-between">
              <p className="text-gray-600">Tax (0%)</p>
              <p className="font-medium">${tax?.toFixed(2)}</p>
            </div>
            <div className="flex justify-between pt-2 border-t mt-2">
              <p className="font-semibold">Total</p>
              <p className="font-semibold">${total?.toFixed(2)}</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default OrderSummary;
